/**
 * Test IDs for QA automation.
 */
export const testIds = {
  commodityDrivenShipmentFormRemoveReceiver: "commodity-driven-shipment-form-remove-receiver",
  commodityDrivenShipmentFormAddReceiver: "commodity-driven-shipment-form-add-receiver",
  commodityDrivenShipmentFormSave: "commodity-driven-shipment-form-save",
  commodityDrivenShipmentFormShipmentDetails: "commodity-driven-shipment-form-shipment-details",
  commodityDrivenShipmentFormReferences: "commodity-driven-shipment-form-references",
  commodityDrivenShipmentFormTrailerRequirementsAccordionSummary: "commodity-driven-shipment-form-trailer-requirements-accordion-summary",
  commodityDrivenShipmentFormRecurrenceAccordionSummary: "commodity-driven-shipment-form-recurrence-accordion-summary",
} as const;
